export default "__VITE_ASSET__B9XVR3c5__"